export enum PollingIntervals {
  halfMin = 30_000,
  long = 10_000,
  default = 5_000,
  everyTwoSeconds = 2_000,
  everySecond = 1_000,
  zero = 0,
}
